import Notification from '../../components/Notification/Notification';
import responseCodes from '../../constants/responseCodes';
import i18n from '../../i18n';
import * as referRequestService from '../../services/referRequestService';
import globalActionConstants from '../constants/globalActionConstants';
import * as referRequestActionConstants from '../constants/referRequestActionConstants';

const t = (key) => i18n.t(key, { ns: 'common' });

export function saveCandidateInfo(params, successCallBack = {}) {
  return async (dispatch) => {
    try {
      dispatch({ type: globalActionConstants.SET_LOADING_ON });

      const response = await referRequestService.saveCandidateInfo(params);

      if (response.data.response_code !== responseCodes.RECORD_ALREADY_EXISTS) {
        dispatch({ type: globalActionConstants.SET_LOADING_OFF });
        dispatch({
          type: referRequestActionConstants.APPLICATION_REQUEST_SUCCESS,
          payload: response.data.payload,
        });
        successCallBack();
      } else {
        dispatch({ type: referRequestActionConstants.APPLICATION_REQUEST_FAILURE });
        Notification.error(response.data.error);
      }
    } catch (error) {
      dispatch({ type: globalActionConstants.SET_LOADING_OFF });
      Notification.error(error.data?.error || t('notifications.failedToSaveCandidateInfo'));
    }
  };
}
